import React, { ReactElement } from 'react';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { Langue } from '../../../../../common/src/entities';
import { ChampLangue } from './DetailsLangue';

const CREER_LANGUE: string = 'Création de la langue ' as const;
const CREER_NOUVELLE_LANGUE: string = "Création d'une nouvelle langue" as const;

/**
 * Page de création d'une entité Langue contenant le formulaire à remplir
 *
 * @returns page html du formulaire
 */
export default function CreerLangue(props: Partial<PropsDeCreationEntite<Langue>>): ReactElement {
    /**
     * Retourne un titre différent dépendemment de si on a rentré un nom pour la langue ou pas
     * @param t le nom de langue
     * @returns un titre pour le popup
     */
    function afficherEntete(t: Langue): ReactElement {
        if (t.name)
            return (
                <>
                    <small className="text-muted">{CREER_LANGUE}</small>
                    {t.name}
                </>
            );

        return <small className="text-muted">{CREER_NOUVELLE_LANGUE}</small>;
    }

    return (
        <FormulaireCreationEntite texteEntete={afficherEntete} entite={Langue} {...props}>
            <ChampLangue />
        </FormulaireCreationEntite>
    );
}
